import Base from './base';

export default class LineItem extends Base {
  resource = '/line_items';
}

